<template>
  <div class="order-detail f-c" v-loading="loadingOrderDetail">
    <order-detail-stats :order-id="orderId" :rii-order-no="riiOrderNo" />
    <div class="functions-board">
      <div class="f-r-vc detail-page-basic-info" style="gap: 20px">
        <span class="entity-no">{{ riiOrderNo }}</span>
        <el-tag type="primary" effect="dark">{{ orderType }}</el-tag>
        <el-tag :type="orderStatusTag" effect="dark">{{ orderStatus }}</el-tag>
      </div>
      <div
        class="features f-r-vc"
        v-if="orderStatus != OrderStatus.OrderDeleted"
      >
        <el-button
          type="success"
          class="feature-secondary"
          v-if="
            orderType === UnloadingOrder &&
            orderStatus === OrderStatus.OrderCreated
          "
          @click="
            goToCreateJob({ jobType: UnloadingJob, orderNo, containerId })
          "
        >
          <svg-icon icon-class="start" class="svg-white-color" />
          Start Unloading
        </el-button>
        <el-button
          type="success"
          class="feature-secondary"
          v-if="orderType === ScanOrder && orderStatus === OrderStatus.OrderCreated"
          @click="openConfirmForScanProcessing"
        >
          <svg-icon icon-class="start" class="svg-white-color" />
          Start Scanning
        </el-button>
        <el-button
          type="success"
          class="feature-secondary"
          v-if="[UnloadingOrder].includes(orderType)"
          @click="goToJobDetail(unloadingJobNo)"
        >
          <svg-icon
            icon-class="info"
            class="svg-white-color"
            style="font-size: 18px"
          />
          Unloading {{ unloadingJobNo }}
        </el-button>
        <el-button
          type="success"
          class="feature-secondary"
          v-if="[DirectOrder, UnloadingOrder].includes(orderType)"
          @click="goToOrderDo(order.no)"
        >
          <svg-icon
            icon-class="print"
            class="svg-white-color"
            style="font-size: 19px"
          />
          PickingUp DO
        </el-button>
        <el-button
          type="success"
          class="feature-secondary"
          v-if="orderType === LocalOrder"
          @click="openLocalPalletsDialog()"
        >
          <svg-icon icon-class="plus" class="svg-white-color" />
          New Group
        </el-button>
        <el-button
          type="success"
          class="feature-secondary"
          v-if="orderType === LocalOrder"
          @click="printLocalPalletLabels()"
        >
          <svg-icon
            icon-class="labels"
            class="svg-white-color"
            style="font-size: 16px"
          />
          Pallet Labels
        </el-button>
        <el-button
          type="success"
          class="feature-secondary"
          v-if="[LocalOrder, ScanOrder].includes(orderType)"
          @click="getOrderReceipt()"
        >
          <svg-icon
            icon-class="print"
            class="svg-white-color"
            style="font-size: 19px"
          />
          Receipt
        </el-button>
        <el-button
          type="warning"
          class="feature-secondary"
          v-if="[DirectOrder, UnloadingOrder].includes(orderType)"
          @click="editOrderType"
        >
          <svg-icon
            icon-class="pencil"
            class="svg-white-color"
            style="font-size: 15px"
          />
          Change Order Type
        </el-button>
        <el-button
          v-if="orderWorking"
          type="warning"
          class="feature-secondary"
          @click="completeOrder"
        >
          <svg-icon
            icon-class="trash"
            class="svg-white-color"
            style="font-size: 14px"
          />
          Complete Order
        </el-button>
        <el-button type="danger" class="feature-secondary" @click="deleteOrder">
          <svg-icon
            icon-class="trash"
            class="svg-white-color"
            style="font-size: 14px"
          />
          Delete Order
        </el-button>
        <el-button type="success" class="feature-secondary" @click="openQrCode">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px"
        />QR Code
      </el-button>
      </div>
    </div>
    <order-info :order-id="orderId" :order="order" />
    <OrderVCInfo :order-id="orderId" :orderVC="order?.vcInfo" :order-status="orderStatus" />
    <container-info
      v-if="[DirectOrder, UnloadingOrder].includes(orderType)"
      :order-status="orderStatus"
      :container-id="containerId"
      :container="container"
    />
    <delivery-info
      v-if="orderType === DirectOrder"
      :order-id="orderId"
      :order-status="orderStatus"
      :delivery-info="deliveryInfoDetail"
    />
    <div class="tabs">
      <el-tabs
        v-model="selectedTab"
        @tab-click="selectTabChange"
        v-if="orderType"
      >
        <el-tab-pane
          v-if="[DirectOrder, UnloadingOrder].includes(orderType)"
          label="Packing List"
          :name="PackingListTab"
        >
          <packing-list
            :queryParams="this.orderId ? { orderId: this.orderId } : null"
          >
            <template v-slot:actions="props">
              <div class="actions f-r">
                <el-button
                  size="small"
                  :disabled="orderStatus === OrderDeleted"
                  type="text"
                  @click="() => modifyGoods(props.row, props.index)"
                >
                  Edit
                </el-button>
                <el-button
                  size="small"
                  type="text"
                  :disabled="orderStatus === OrderDeleted"
                  class="danger-text"
                  @click="() => deleteGoods(props.row)"
                >
                  Delete
                </el-button>
                <el-button
                  size="small"
                  type="text"
                  :disabled="orderStatus === OrderDeleted"
                  class="success-text"
                  @click="() => newGoodsNote(props.index, props.row)"
                >
                  New Note
                </el-button>
              </div>
            </template>
          </packing-list>
        </el-tab-pane>
        <el-tab-pane
          v-if="orderType === LocalOrder"
          label="Pallets Groups"
          :name="LocalPalletsGroupTab"
        >
          <local-pallets-info
            :local-pallets="orderLocalPallets"
            :order-id="orderId"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="[LocalOrder, UnloadingOrder, ScanOrder].includes(orderType)"
          label="All Pallets"
          :name="PalletListTab"
        >
          <pallet-list
            :palletQuery="{ orderIds: [orderId] }"
            :exclude-cols="orderType === ScanOrder ? ['riiContainerNo'] : []"
            :refresh="loadingOrderDetail"
            :has-row-expand="orderType === ScanOrder"
          >
          <template v-slot:row-expand="props">
            <div class="pallets-products">
              <pallet-scan-products :pallet-id="props.row.id" />
            </div>
          </template>
          </pallet-list>
        </el-tab-pane>
        <el-tab-pane
          label="Customer Orders"
          :name="CustomerOrdersTab"
          v-if="ScanOrder === orderType"
        >
          <scan-order-group-list :order-id="order.id" :products-query="{orderIds: [orderId]}" />
        </el-tab-pane>
        <el-tab-pane
          label="Jobs"
          :name="JobListTab"
          v-if="[LocalOrder, UnloadingOrder].includes(orderType)"
        >
          <job-list
            :jobQuery="{ orderIds: [orderId] }"
            :refresh="loadingOrderDetail"
          />
        </el-tab-pane>
        <el-tab-pane label="Notes" name="NotesTab">
          <el-button
            size="small"
            plain
            type="primary"
            @click="newOrderNote"
            :disabled="orderStatus === OrderDeleted"
          >
            Add New Note
          </el-button>
          <note-list
            :disabled="orderStatus === OrderDeleted"
            :notes="notes"
            :changeCb="modifyJobNotes"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <goods-edit ref="goodsEdit" />
    <order-type-edit ref="typeEdit" :order-id="orderId" />
    <note-edit ref="newNote" />
    <order-complete
      ref="orderComplete"
      :order-id="orderId"
      :cb="getOrderDetail"
    />
    <dialog-edit-or-create
      ref="localPalletsEdit"
      :formInputInit="InitLocalPalletsForm"
    />
    <confirm-dialog
      ref="scanOrderProcessing"
      title="Start Processing Scan Order"
      :confirmCb="startScanProcessing"
      :width="30"
    >
      <template v-slot:content>
        <div>
          Will create upcoming pallets for current order, continue?
        </div>
      </template>
    </confirm-dialog>
    <common-dialog ref="qrCode" class="qr-code">
      <template v-slot:content>
        <img :src="src" />
      </template>
    </common-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcode'
// others
import { FormModes } from '@/core/configs/types'
// msg
import PagesMessage from '@/core/message/pages'
// apis
import {
  detailOrder,
  modifyOrder,
  deleteOrder,
  newLocalPallets,
  labelLocalPallets,
  localOrderReceipt
} from '@/api/order'
import { removeGoods, modifyGoodsNotes } from '@/api/goods'
// models
import {
  InitLocalPalletsForm,
  OrderInfoWrapUp,
  DirectOrder,
  LocalOrder,
  OrderDeleted,
  OrderProcessing,
  UnloadingOrder,
  OrderStatus,
  LocalPalletGroupWrapUp,
  OrderCompleted,
  OrderCreated,
  ScanOrder
} from '@/core/models/order'
import { UnloadingJob, ScanPalletJob } from '@/core/models/constant'
// mixin
import { pageJumps } from '@/core/mixin/pages'
import {
  LocalOrderTabs,
  ScanOrderTabs,
  TabsMixin,
  UnloadingOrderTabs
} from '@/core/mixin/tabs'
// components
import OrderDetailStats from '@/components/order/OrderDetailStats.vue'
import OrderInfo from '@/components/order/OrderInfo.vue'
import OrderVCInfo from '@/components/order/OrderVCInfo.vue'
import ContainerInfo from '@/components/container/ContainerInfo.vue'
import DeliveryInfo from '@/components/order/DeliveryInfo.vue'
import PackingList from '@/components/goods/PackingList.vue'
import GoodsEdit from '@/components/goods/GoodsEdit.vue'
import JobList from '@/components/jobs/JobList.vue'
import NoteList from '@/components/note/NoteList.vue'
import OrderTypeEdit from '@/components/order/OrderTypeEdit.vue'
import NoteEdit from '@/components/note/NoteNew.vue'
import PalletList from '@/components/pallet/PalletList.vue'
import LocalPalletsInfo from '@/components/order/LocalPalletsInfo.vue'
import DialogEditOrCreate from '@/components/common/DialogEditOrCreate.vue'
import OrderComplete from '@/components/order/OrderComplete.vue'
import ScanOrderGroupList from '@/components/order/ScanOrderGroupList.vue'
import ConfirmDialog from '@/components/common/Confirm.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import PalletScanProducts from '@/components/pallet/PalletScanProducts.vue'
import { viewPdf } from '@/core/utils'
export default {
  name: 'OrderDetail',
  mixins: [pageJumps, TabsMixin],
  components: {
    OrderInfo,
    OrderVCInfo,
    OrderDetailStats,
    ContainerInfo,
    DeliveryInfo,
    PackingList,
    GoodsEdit,
    JobList,
    NoteList,
    OrderTypeEdit,
    NoteEdit,
    PalletList,
    LocalPalletsInfo,
    DialogEditOrCreate,
    OrderComplete,
    ScanOrderGroupList,
    ConfirmDialog,
    CommonDialog,
    PalletScanProducts
  },
  data() {
    return {
      InitLocalPalletsForm,
      FormModes,
      DirectOrder,
      UnloadingJob,
      ScanPalletJob,
      UnloadingOrder,
      LocalOrder,
      ScanOrder,
      OrderDeleted,
      OrderProcessing,
      loadingOrderDetail: false,
      order: null,
      OrderStatus,
      src: null
    }
  },
  mounted() {
    this.getOrderDetail()
    PagesMessage.on(
      PagesMessage.eventMap.REFRESH_ORDER_DETAIL,
      this.getOrderDetail
    )
  },
  beforeDestroy() {
    PagesMessage.off(
      PagesMessage.eventMap.REFRESH_ORDER_DETAIL,
      this.getOrderDetail
    )
  },
  computed: {
    selectedTab: {
      get() {
        return this.$route.query.tab
      },
      set(value) {
        this.goToOrderDetail(this.orderNo, { tab: value })
      }
    },
    orderId() {
      return this.order?.id ?? ''
    },
    orderType() {
      return this.order?.type
    },
    riiOrderNo() {
      return this.order?.riiOrderNo
    },
    orderNo() {
      return this.$route.params.no
    },
    orderStatus() {
      return this.order?.status
    },
    orderWorking() {
      return (
        this.orderStatus === OrderCreated ||
        this.orderStatus === OrderProcessing
      )
    },
    orderStatusTag() {
      switch (this.orderStatus) {
        case OrderDeleted:
          return 'danger'
        case OrderCompleted:
          return 'success'
        default:
          return 'primary'
      }
    },
    deliveryInfoDetail() {
      return this.order?.directDeliveryInfo
    },
    containerId() {
      return this.order?.container?.id ?? ''
    },
    orderDetail() {
      return OrderInfoWrapUp(this.order ?? {})
    },
    container() {
      return this?.order?.container ?? {}
    },
    goodsIds() {
      return this.order?.goodsIds ?? []
    },
    pickingUpInfo() {
      return this.order?.container?.pickUpInfo ?? {}
    },
    orderLocalPallets() {
      return this.order?.localPallets ?? []
    },
    jobIds() {
      return this.order?.jobIds ?? []
    },
    unloadingJobNo() {
      return this.order?.unloadingJobNo ?? ''
    },
    notes() {
      return this.order?.notes ?? []
    }
  },
  methods: {
    openConfirmForScanProcessing(flag) {
      this.$refs.scanOrderProcessing.open()
    },
    async getOrderDetail() {
      this.loadingOrderDetail = true
      const order = await detailOrder(this.orderNo)
      this.$set(this, 'order', order)
      this.correctTab()
      this.loadingOrderDetail = false
    },
    correctTab() {
      if ([UnloadingOrder, DirectOrder].includes(this.orderType)) {
        if (!UnloadingOrderTabs.includes(this.selectedTab)) {
          this.$router.replace({
            path: `/order/${this.orderNo}`,
            query: { tab: UnloadingOrderTabs[0] }
          })
        }
      } else if (this.orderType === LocalOrder) {
        if (!LocalOrderTabs.includes(this.selectedTab)) {
          this.$router.replace({
            path: `/order/${this.orderNo}`,
            query: { tab: LocalOrderTabs[0] }
          })
        }
      } else if (this.orderType === ScanOrder) {
        if (!ScanOrderTabs.includes(this.selectedTab)) {
          this.$router.replace({
            path: `/order/${this.orderNo}`,
            query: { tab: ScanOrderTabs[0] }
          })
        }
      }
    },
    async getSrc() {
      const src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'Product',
          sku: 'TEST-1',
          sscc: '123456789'
        })
      )
      this.src = src
    },
    openQrCode() {
      this.getSrc().then(e => this.$refs.qrCode.open())
    },
    selectTabChange() {},
    // --------------------- for goods modification and delete ---------------------
    modifyGoods(row, index) {
      this.$refs.goodsEdit.open(row.id, () => {
        PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
      })
    },
    deleteGoods(row) {
      this.$confirm('Remove goods, continue?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        removeGoods(row.id).then(() => {
          this.$message({
            type: 'success',
            message: 'Successfully delete goods!'
          })
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
        })
      })
    },
    newGoodsNote(index, goods) {
      const saveNote = (newNote, done, error) => {
        modifyGoodsNotes(goods.id, [...goods.notes, newNote])
          .then(() => {
            done()
            this.$message({
              type: 'success',
              message: 'Successfully add a new note!'
            })
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
          })
          .catch(err => {
            error(err)
          })
      }
      this.$refs.newNote.open(saveNote)
    },
    // --------------------- for order modification and delete ---------------------
    newOrderNote() {
      const saveNote = (newNote, done, error) => {
        modifyOrder(this.orderId, { notes: [...this.notes, newNote] })
          .then(() => {
            done()
            this.$message({
              type: 'success',
              message: 'Successfully add a new order note!'
            })
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
          })
          .catch(err => {
            error(err)
          })
      }
      this.$refs.newNote.open(saveNote)
    },
    modifyJobNotes(notes) {
      modifyOrder(this.orderId, { notes }).then(res => {
        PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
      })
    },
    editOrderType() {
      this.$refs.typeEdit.open(this.orderType)
    },
    deleteOrder() {
      this.$confirm(`Delete order ${this.order.riiOrderNo}`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        // delete order
        deleteOrder(this.order.id).then(res => {
          if (res) {
            this.$message.success('Delete order successfully!')
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
          }
        })
      })
    },
    completeOrder() {
      this.$refs.orderComplete.open()
    },
    openLocalPalletsDialog() {
      this.$refs.localPalletsEdit.open(null, this.createLocalPallets)
    },
    createLocalPallets(data, done, error) {
      newLocalPallets(this.orderId, LocalPalletGroupWrapUp(data))
        .then(res => {
          if (res) {
            this.$message.success('create local pallets successfully!')
            done()
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
          }
        })
        .catch(err => {
          error(err)
        })
    },
    printLocalPalletLabels() {
      labelLocalPallets(this.orderId).then(res => {
        if (res) viewPdf(res)
      })
    },
    getOrderReceipt() {
      localOrderReceipt(this.orderId).then(res => {
        if (res) viewPdf(res)
      })
    },
    startScanProcessing(close, error) {
      // this.$refs.scanOrderProcessing.open()
      modifyOrder(this.orderId, { status: OrderProcessing }).then(res => {
        PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
        close()
      }).catch(err => {
        error(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.order-detail {
  margin-bottom: 20px;

  .order-detail-stats {
    @extend .global-margin;
  }
}

.tabs {
  @extend .global-margin;
  @extend .shadow-level-three;

  border-radius: $home-card-border-radius;
  padding: $home-card-padding-y $home-card-padding-x;
  background-color: white;
}

.functions-board {
  @extend .common-card-margin;
  @extend .f-c;

  gap: 20px;
  justify-content: space-between;

  .el-button {
    border: none;
  }

  .features {
    flex-wrap: wrap;
    gap: 10px;

    .el-button {
      margin-left: 0 !important;
    }
  }
}

.actions {
  flex-wrap: wrap;
}
.pallets-products {
  padding: 5px 20px;
}
</style>
